<script>

    import { toast } from 'bulma-toast'
    import { userStore, accountsStore, modalStore } from '../stores'

    import AccountsService from '../$services/accounts.service'
    import DateMethod from '../$methods/date.method'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Pagination from '../$components/pagination.svelte'
    import Select from '../$components/select.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/modal.container.svelte'

    export let all = false

    let query = {
        page: 0,
        find: null
    }
    let metadata = {}
    let loading = false
    let element

    getAccounts()

    async function getAccounts() {

        if(all)
            query.admin = true
        else
            query.userId = $userStore._id

        loading = true
        const resp = await AccountsService.getAccounts(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountsStore.set(resp.data.accounts)
        metadata = resp.data.metadata
    }

    async function getAccountsReport() {

        loading = true
        const blob = await AccountsService.getAccountsReport()
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        let fileName = 'Reporte_cuentas'

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Table items={ $accountsStore.length } total={ metadata.total } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={ query.find } on:enter={ getAccounts } />
            </div>
            <div class="column is-narrow">
                <Select bind:value={ query.status } on:change={ getAccounts }
                    text="Estatus de pago"
                    options={[
                        {value: 'pending', text: 'Pendiente'},
                        {value: 'paid', text: 'Pagado'},
                        {value: 'free', text: 'Gratis'},
                    ]}
                />
            </div>
            <div class="column is-narrow">
                <div class="accounts-toolbar-actions">
                    <Button on:click={getAccountsReport} icon="file-excel" text="Descargar reporte" />
                    {#if !all}
                        <Button on:click={() => modalStore.set('account_create_modal')} text="Agregar" icon="plus" />
                    {/if}
                </div>
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getAccounts } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Usuario</th>
            <th>Pago</th>
            <th>Estatus</th>
            <th>Envios</th>
            <th>Corte</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $accountsStore as account, index}
            <tr>
                <td>{(metadata.items * query.page) + (index + 1)}</td>
                <td>
                    <div>
                        <span>{account.user.name}</span>
                        <span>{account.user.email}</span>
                    </div>
                </td>
                <td>{TranslateMethods.get(account.status)}</td>
                <td>{DateMethod.isAfter(account.expired) ? 'Activo' : 'Expiró'}</td>
                <td>{account.shipments.length}</td>
                <td>{DateMethod.dateLarge(account.expired)}</td>
                <td>
                    <Button on:click={() => modalStore.open('account', 'modal', account)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
